module.exports = __webpack_public_path__ + "static/media/UC_black.139db457.svg";